require('./bootstrap');

import Vue from 'vue';
window.Vue = Vue;
import LibrarySearch from './components/LibrarySearch';
import LibraryTagSearch from './components/LibraryTagSearch';
import LibraryModerate from './components/LibraryModerate';
import LibrarySingle from './components/LibrarySingle';
import TagsList from './components/TagsList';
import Buefy from 'buefy'
Vue.use(Buefy)

const app = new Vue({
    el: '#app',
    components: {
        'library-search': LibrarySearch,
        'library-tag-search': LibraryTagSearch,
        'library-moderate': LibraryModerate,
        'library-single': LibrarySingle,
        'tags-list': TagsList
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js